const PATHS = [
  "M29.46,10.35 L17.07,12.66 L19.60,17.04 Z",
  "M14.33,30.78 L18.53,18.90 L13.47,18.90 Z",
  "M4.21,7.46 L12.40,17.04 L14.93,12.66 Z",
];

export default function BrandKarmaLogo({
  size = 32,
  color = "currentColor",
  bg,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
    >
      {bg ? <rect width="32" height="32" rx="6" fill={bg} /> : null}
      {PATHS.map((d) => (
        <path key={d} d={d} fill={color} />
      ))}
    </svg>
  );
}
